import {
  SELECT_BOX_LIST,
  PACKAGE_LIST,
  PACKAGE_DATA,
  COMPANY_LIST,
  COMPANY_DATA,
  BRANCH_LIST,
  BRANCH_DATA,
  CATEGORY_LIST,
  CATEGORY_DATA,
  CATEGORY_SELECTBOX_LIST,
  SUB_CATEGORY_LIST,
  SUB_CATEGORY_DATA,
  SUB_CATEGORY_SELECTBOX_LIST,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  IS_LOADING,
  LOGOUT,
  STAFF_SELECTBOX_LIST,
  STAFF_LIST,
  STAFF_DATA,
  USER_LIST,
  USER_DATA,
  CUSTOMER_LIST,
  AUTO_SUGGESSTION_LIST,
  CUSTOMER_DATA,
  ID_SETTING_LIST,
  MAIL_SETTING_LIST,
  MAIL_SENT_LIST,
  STATUS_TYPE_LIST,
  TAX_LIST,
  TAX_SELECTBOX_LIST,
  MENU_LIST,
  AUTHORIZATION_LIST,
  AUTHORIZATION_MENU_LIST,
  AUTHORIZATION_SUB_MENU_LIST,
  FORM_LIST,
  FORM_DATA,
  OBJECT_DATA,
  OBJECT_LIST,
  ITEM_LIST,
  ITEM_SUGGESSTIONS,
  ITEM_DATA,
  ENQUIRY_LIST,
  ENQUIRY_DATA,
  WEB_ENQUIRY_LIST,
  WEB_ENQUIRY_DATA,
  QUOTATION_LIST,
  QUOTATION_DATA,
  PURCHASE_LIST,
  PURCHASE_DATA,
  SALE_LIST,
  SALE_DATA,
  DELIVERY_CHALLLAN_DATA,
  DELIVERY_CHALLLAN_LIST,
  FOOD_ORDER_LIST,
  FOOD_ORDER_DATA,
  FOOD_ORDER_STATUS_LIST,
  FOOD_ITEM_LIST,
  FOOD_ITEM_DATA,
  BANK_LIST,
  MAIL_TEMPLATE_LIST,
  PAYMENT_LIST,
  PAYMENT_DATA,
  RECEIPT_LIST,
  RECEIPT_DATA,
  OUTSTANDING_RECEIVABLE_LIST,
  OUTSTANDING_PAYABLE_LIST,
  STOCK_LIST,
  BANNER_LIST,
  RATINGS_LIST,
  DELIVERY_CHARGES_LIST,
  CUSTOMER_ADDRESS_LIST,

  DEVICE_LIST,
  DESIGN_LIST,
  DEVICE_STATUS_DATA,
} from '../actions/Admin';

const initialState = {
  error_message: '',
  success_message: '',
  is_loading: false,

  selectBoxList: [],
  packageList: [],
  packageData: {},
  companyList: [],
  companyData: {},
  branchList: [],
  branchData: {},
  categoryList: [],
  categoryData: {},
  categorySelectBoxList: [],
  subCategoryList: [],
  subCategoryData: {},
  subCategorySelectBoxList: [],
  staffSelectBoxList: [],
  staffList: [],
  staffData: {},
  userList: [],
  userData: {},
  customerList: [],
  customerAddressList: [],
  autoSuggestionList: [],
  customerData: {},
  idSettingList: [],
  mailSettingList: [],
  mailSentList: [],
  statusTypeList: [],
  taxList: [],
  taxSettingList: [],
  itemList: [],
  itemSuggestions: [],
  itemData: {},
  enquiryList: [],
  enquiryData: {},
  webEnquiryList: [],
  webEnquiryData: {},
  quotationList: [],
  quotationData: {},
  purchaseList: [],
  purchaseData: {},
  saleList: [],
  saleData: {},
  deliveryChallanList: [],
  deliveryChallanData: {},
  menuList: [],
  authorizationList: [],
  authorizationMenuList: [],
  authorizationSubMenuList: [],
  formList: [],
  formData: {},
  objectData: {},
  objectList: [],
  foodItemList: [],
  foodItemData: {},
  foodOrderData: {},
  foodOrderList: [],
  foodOrderStatusList: [],
  bankList: [],
  mailTemplateList: [],
  paymentData: {},
  paymentList: [],
  receiptData: {},
  receiptList: [],
  outstandingPayableList: [],
  outstandingReceivableList: [],
  stockList: [],
  bannerList: [],
  ratingsList: [],
  deliveryChargesList: [],

  deviceList: [],
  deviceDesignList: [],
  deviceStatusData: {},
};

const clearableKeys = [
  'BRANCH', 'COMPANY', 'CATEGORY', 'SUB_CATEGORY', 'STAFF',
  'USER', 'CUSTOMER', 'ITEM', 'ENQUIRY', 'QUOTATION', 'PURCHASE',
  'SALE', 'DELIVERY_CHALLLAN', 'FORM', 'FOOD_ORDER', 'WEB_ENQUIRY', 'PAYMENT', 'RECEIPT'
];

const out = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SELECT_BOX_LIST:
      return { ...state, selectBoxList: payload };

    case AUTO_SUGGESSTION_LIST:
      return { ...state, autoSuggestionList: payload };

    case SUCCESS_MESSAGE:
      return { ...state, success_message: payload };

    case ERROR_MESSAGE:
      return { ...state, error_message: payload };

    case IS_LOADING:
      return { ...state, is_loading: payload };

    case LOGOUT:
      return { ...initialState };

    default:
      // Dynamic handling for *_LIST
      if (/_LIST$/.test(type)) {
        const key = toCamelCase(type);
        return { ...state, [key]: payload };
      }

      // Dynamic handling for *_DATA
      if (/_DATA$/.test(type)) {
        const key = toCamelCase(type);
        return { ...state, [key]: payload };
      }

      // Dynamic handling for CLEAR_* (like CLEAR_QUOTATION, CLEAR_CUSTOMER, etc.)
      if (/^CLEAR_(.*)$/.test(type)) {
        const match = type.match(/^CLEAR_(.*)$/);
        if (match) {
          const upperKey = match[1]; // e.g., "QUOTATION"

          if (clearableKeys.includes(upperKey)) {
            const camelKey = toCamelCase(`${upperKey}_DATA`); // e.g., "quotationData"

            if (camelKey in initialState) {
              return {
                ...state,
                [camelKey]: initialState[camelKey],
              };
            }
          }
        }
      }

      return state;
  }
};

// Converts "BRANCH_LIST" => "branchList", "USER_DATA" => "userData"
function toCamelCase(type) {
  return type
    .toLowerCase()
    .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export default out;